import classnames from "classnames";
import { inject } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Store } from "../../../../client/stores";
import type { SitesTemplateInfernoMicrosite } from "../../generated/webapi.g";
import { trimText } from "../../lib/common";
import { formatImage } from "../../lib/image-asset";
import { MagicLink } from "../../ui";
import { LiveCardType, Thumb } from "../livecard/LiveCard.component";
import "./MicrositeFooter.style.scss";

interface MicrositeFooterProps {
    config: SitesTemplateInfernoMicrosite;
    slug: string;
    store?: Store;
}

const maxChars = 150;

export const MicrositeFooter = inject("store")((props: MicrositeFooterProps) => {
    const { config, store } = props;
    if (!config || !store) {
        return null;
    }

    const { thumbnail_image, description } = config.general || {};
    const { full_bio } = config.contact || {};
    // can have description without thumb but if no description then don't show at all
    if (!description) {
        return null;
    }

    // if they have a full bio show the read more
    const showMore = !!full_bio;
    const minBioClass = classnames("mini-bio", {
        "with-thumb": thumbnail_image,
        "with-read-more": showMore,
    });

    const { t } = useTranslation();
    const personality = t("about", { name: config.general?.name || "" });

    return (
        <div className="component-microsite-footer themed-block">
            <section className="microsite-footer-content">
                <h2 className="footer-title">{personality}</h2>
                <hr className="divider dark" />
                <figure className={minBioClass}>
                    {thumbnail_image ? (
                        <section className="thumb-container">
                            <Thumb
                                imgUrl={store.env ? formatImage(thumbnail_image.id, store.env) : thumbnail_image.id}
                                source={"show"}
                                type={LiveCardType.MICROSITE}
                                alt={personality}
                            />
                        </section>
                    ) : null}
                    <figcaption>
                        <p className="microsite-description">
                            {showMore ? (
                                <MagicLink to={`/featured/${props.slug}/about`}>
                                    {trimText(description, maxChars)}
                                    <span className="readmore">{t("readmore")}</span>
                                </MagicLink>
                            ) : (
                                description
                            )}
                        </p>
                    </figcaption>
                </figure>
            </section>
        </div>
    );
});

export default MicrositeFooter;
